import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { FileDetails } from "@main/file-storage";
import { DocumentType } from "@main/file-storage/document-type";

@Injectable()
export class DocumentUploaderService extends BaseDataService {
    readonly url = "api/document-upload/request";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    async uploadDocument(requestId: string, docType: DocumentType, uploadDateTime: Date, files: File[]) {
        if (!files?.length) {
            return [];
        }

        const formData = new FormData();
        formData.set("documentType", docType.toString());
        formData.set("uploadDateTime", uploadDateTime.toISOString());

        for (const file of files) {
            formData.append("files", file);
        }

        const fileDetails = await this.handleRequest(this.http.post<FileDetails[]>(`${this.url}/${requestId}/upload`, formData));
        return fileDetails;
    }
}
